(function () {
 function locationInfo() {
  var c = document.querySelector('input[type="radio"]:checked');
  var box = c && c.closest('label,div');
  var t = box ? box.textContent : '';
  var loc = '';

  if (/lethbridge/i.test(t)) loc = 'lethbridge';
  if (/saint john/i.test(t)) loc = 'saintjohn';

  var card = null;

  if (loc === 'lethbridge') {
    card = document.querySelector('.location-container.multiloca-lethbridge');
  }

  if (loc === 'saintjohn') {
    card = document.querySelector('.location-container.multiloca-saintjohn');
  }

  var stockText = card ? card.innerText : t;

  return {
    location: loc,
    text: stockText,
    hasStock: /\bin stock\b/i.test(stockText)
  };
}
  function sync(root) {
    if (!root) return;

    var b = root.querySelector('button[name="add"],.add-to-cart');
    if (!b) return;

    var info = locationInfo();
    var loc = info.location;

    var n =
      loc === 'lethbridge'
        ? Number(root.dataset.dbsIncomingLethbridge || 0)
        : loc === 'saintjohn'
        ? Number(root.dataset.dbsIncomingSaintJohn || 0)
        : 0;

    var excluded = /(clearance|discontinued|last chance)/i.test(
      root.dataset.dbsProductTags || ''
    );

    var note = root.querySelector('.dbs-location-incoming-note');

    /*
      PRE-ORDER only when:
      - a valid store is selected
      - incoming quantity is greater than zero
      - product is not excluded
      - selected store does NOT have physical stock
    */
    if (loc && n > 0 && !excluded && !info.hasStock) {
      b.disabled = false;
      b.removeAttribute('disabled');
      b.classList.remove('disabled');
      b.dataset.dbsLocationVisualDisabled = 'false';

      b.setAttribute(
        'data-add-to-cart-text',
        'PRE-ORDER – INCOMING STOCK'
      );
      b.textContent = 'PRE-ORDER – INCOMING STOCK';

      if (!note) {
        note = document.createElement('div');
        note.className = 'dbs-location-incoming-note';
        note.style.marginTop = '10px';
        b.parentNode.appendChild(note);
      }

      note.innerHTML =
        '<strong>Incoming stock – pre-order available</strong><br>' +
        n +
        ' already on the way to ' +
        (loc === 'lethbridge' ? 'Lethbridge' : 'Saint John') +
        '. Order now to reserve yours. It is not physically available for pickup until received.';

      root
        .querySelectorAll(
          'pickup-availability,[data-dynamic-variant-content*="pickup-availability"]'
        )
        .forEach(function (x) {
          x.style.display = 'none';
        });

      return;
    }

    /*
      Not currently a preorder.
      Remove the incoming message and restore normal pickup display.
    */
    if (note) {
      note.remove();
    }

    root
      .querySelectorAll(
        'pickup-availability,[data-dynamic-variant-content*="pickup-availability"]'
      )
      .forEach(function (x) {
        x.style.display = '';
      });

    /*
      If this script previously changed the button to PRE-ORDER,
      restore the normal button when physical stock is available.
    */
    if (
      info.hasStock &&
      b.getAttribute('data-add-to-cart-text') ===
        'PRE-ORDER – INCOMING STOCK'
    ) {
      b.setAttribute('data-add-to-cart-text', 'ADD TO CART');
      b.textContent = 'ADD TO CART';
      b.disabled = false;
      b.removeAttribute('disabled');
      b.classList.remove('disabled');
      b.dataset.dbsLocationVisualDisabled = 'false';
    }
  }

  function all() {
    document
      .querySelectorAll('product-form,.js-product')
      .forEach(sync);
  }

  document.addEventListener('change', function () {
    setTimeout(all, 50);
    setTimeout(all, 250);
  });

  document.addEventListener('click', function () {
    setTimeout(all, 100);
    setTimeout(all, 350);
  });

  document.addEventListener('on:variant:change', function () {
    setTimeout(all, 50);
    setTimeout(all, 300);
  });

  new MutationObserver(function () {
    clearTimeout(window.__dbsPre);
    window.__dbsPre = setTimeout(all, 80);
  }).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', all);
  } else {
    all();
  }
})();